export interface QueueAssignmentPolicyCopyInput {
  assignmentType?: string | null;
  policyReason?: string | null;
}

export function getQueueAssignmentPolicyCopy({
  assignmentType,
  policyReason,
}: QueueAssignmentPolicyCopyInput): string | null {
  if (assignmentType === "fresh") {
    if (policyReason === "fresh_immediate_ready") return "Fresh court assigned";
    if (policyReason === "fresh_target_reached")
      return "Fresh court block — target occupancy ready";
    if (policyReason === "fresh_max_wait_reached")
      return "Fresh court block — maximum wait reached";
    if (policyReason === "fresh_exclusive_party")
      return "Fresh court block — exclusive party";
    return null;
  }
  if (
    assignmentType === "top_off" &&
    policyReason === "filled_existing_court"
  ) {
    return "Joined an active court with enough time remaining";
  }
  if (
    assignmentType === "top_off" &&
    policyReason === "extended_existing_court"
  ) {
    return "Joined an active court with an extended block";
  }
  return null;
}
